import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject, _templateObject2;
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';
import * as colors from '@atlaskit/theme/colors';
import { N40 } from '@atlaskit/theme/colors';
import { gs as gridSize } from '../../common/utils';
export var className = 'media-card-frame';
export var borderRadius = "\n  border-radius: ".concat("var(--ds-border-radius, 3px)", ";\n");
var wrapperBorderRadius = "\n  border-radius: ".concat("var(--ds-border-radius-200, 8px)", ";\n");
var contentBorderRadius = "\n  border-radius: ".concat("var(--ds-border-radius-100, 4px)", ";\n");
export var ellipsis = function ellipsis() {
  var maxWidth = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '100%';
  var unit = typeof maxWidth === 'number' ? 'px' : '';
  return "\n    max-width: ".concat(maxWidth).concat(unit, ";\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  ");
};
export var csssize = function csssize() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '100%';
  var unit = typeof value === 'number' ? 'px' : '';
  return "\n    width: ".concat(value).concat(unit, ";\n    height: ").concat(value).concat(unit, ";\n  ");
};
function minWidth(_ref) {
  var minWidth = _ref.minWidth;
  if (minWidth) {
    return "min-width: ".concat(minWidth, "px;");
  } else {
    return '';
  }
}
function maxWidth(_ref2) {
  var maxWidth = _ref2.maxWidth;
  if (maxWidth) {
    return "max-width: ".concat(maxWidth, "px; margin: 0 auto;");
  } else {
    return 'margin: 0 auto;';
  }
}
function getInteractiveStyles(_ref3) {
  var isInteractive = _ref3.isInteractive,
    frameStyle = _ref3.frameStyle;
  return isInteractive ? "\n      &:hover {\n        ".concat(frameStyle !== 'hide' && visibleStyles, "\n\n      }\n      &:active {\n        background-color: ", "var(--ds-background-selected, ".concat(colors.B50, ")"), ";\n      }\n    ") : '';
}
function selected(_ref4) {
  var isSelected = _ref4.isSelected,
    frameStyle = _ref4.frameStyle;
  return isSelected && frameStyle !== 'hide' ? "\n    ".concat(visibleStyles, "\n    &::after {\n      cursor: pointer;\n      box-shadow: 0 0 0 3px ", "var(--ds-border-selected, ".concat(colors.B100, ")"), ";\n      content: '';\n      border: none;\n      position: absolute;\n      height: 100%;\n      width: 100%;\n      left: 0;\n      ").concat(wrapperBorderRadius, "\n    }\n    ") : isSelected && frameStyle === 'hide' ? contentBorderRadius : '';
}
var height = function height(_ref5) {
  var inheritDimensions = _ref5.inheritDimensions;
  return inheritDimensions ? 'height: 100%;' : "height: ".concat(gridSize(54));
};
var wrapperStyles = function wrapperStyles(props) {
  return "\n  ".concat(wrapperBorderRadius, "\n  ").concat(minWidth(props), "\n  ").concat(maxWidth(props), "\n  ").concat(getInteractiveStyles(props), "\n  ").concat(visible(props), "\n  display: inline-flex;\n  flex-direction: column;\n  box-sizing: border-box;\n  font-family: ", "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)", ";\n  width: 100%;\n  user-select: none;\n  line-height: initial;\n  transition: background 0.3s;\n  position: relative;\n  ").concat(height(props), ";\n  ").concat(selected(props), "\n\n  &:after {\n    content: '';\n    transition: background 0.3s, box-shadow 0.3s;\n    position: absolute;\n    height: calc(100% + ", "var(--ds-space-100, 8px)", ");\n    ").concat(wrapperBorderRadius, "\n\n    ").concat(wrapperSizing(props), "\n  }\n");
};

// if frameStyle !== 'show' then set the width of the frame to be
// 100% of the content +16px and position it left -8px to make it appear
// outside the container
var wrapperSizing = function wrapperSizing(_ref6) {
  var frameStyle = _ref6.frameStyle;
  return frameStyle === 'show' ? "\n    box-sizing: border-box;\n    width: 100%;" : "\n    width: calc(100% + ".concat("var(--ds-space-200, 16px)", ");\n    left: ", "var(--ds-space-negative-100, -8px)", ";");
};
var visibleStyles = "\n  &:after {\n    border: 1px solid ".concat("var(--ds-border, ".concat(N40, ")"), ";\n    background-color: ", "var(--ds-surface-raised, white)", ";\n  }\n  .embed-header {\n    opacity: 1;\n  }");
function visible(_ref7) {
  var frameStyle = _ref7.frameStyle;
  return frameStyle === 'show' ? visibleStyles : '';
}

// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var LinkWrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\t", " &:hover {\n\t\ttext-decoration: none;\n\t}\n"])), function (props) {
  return wrapperStyles(props);
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
export var Wrapper = styled.div(function (props) {
  return wrapperStyles(props);
}, {
  // We are keeping this margin as a hardcoded variable as it is not a standard token size and needs
  // to be thoroughly checked with a designer so that we do not miss an unintended visual change
  // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
  marginTop: '10px'
});
export var embedHeaderHeight = 32;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var Header = styled.div({
  height: "".concat(embedHeaderHeight, "px"),
  position: 'absolute',
  zIndex: 1,
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
  color: "var(--ds-icon, ".concat(colors.N300, ")"),
  opacity: 0,
  transition: '300ms opacity cubic-bezier(0.15, 1, 0.3, 1)'
},
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
function (_ref8) {
  var frameStyle = _ref8.frameStyle;
  return frameStyle === 'show' ? "\n        box-sizing: border-box;\n        padding: 0 ".concat("var(--ds-space-100, 8px)", ";\n      ") : '';
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var IconWrapper = styled.div(
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
borderRadius,
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
csssize(16),
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
function (_ref9) {
  var isPlaceholder = _ref9.isPlaceholder;
  if (isPlaceholder) {
    return "\n\t\t\t".concat("\n      background-color: ", "var(--ds-skeleton, ".concat(colors.N30, ")"), ";\n    ");
  } else {
    return '';
  }
}, {
  marginRight: "var(--ds-space-050, 4px)"
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var TextWrapper = styled.div(
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
function (_ref10) {
  var isPlaceholder = _ref10.isPlaceholder;
  if (isPlaceholder) {
    return "\n        ".concat(borderRadius, "\n        width: 125px;\n        height: 12px;\n", "\n        background-color: ", "var(--ds-skeleton, ".concat(colors.N30, ")"), ";\n      ");
  } else {
    return '';
  }
}, {
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
  color: "var(--ds-text-subtlest, ".concat(colors.N300, ")"),
  font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
},
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
ellipsis('none'));

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var TooltipWrapper = styled.div({
  overflow: 'hidden'
});
// NB: `overflow` is kept as `hidden` since
// the internal contents of the `iframe` should
// manage scrolling behaviour.
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var Content = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\t", ";\n\tborder: 1px solid ", ";\n\tbackground-color: ", ";\n\tposition: absolute;\n\tz-index: 1;\n\twidth: 100%;\n\ttransition: box-shadow 0.3s;\n\n\t> .calc-height > div > div {\n\t\tleft: unset !important;\n\t\twidth: unset !important;\n\t\theight: unset !important;\n\t\tposition: initial !important;\n\t\tpadding-bottom: unset !important;\n\t}\n\t> .embed-preview > div {\n\t\tmargin: 0 auto;\n\t}\n\n\t", "\n\n\t", "\n\n  ", "\n"])), contentBorderRadius, "var(--ds-border, ".concat(N40, ")"), "var(--ds-surface-raised, white)", function (_ref11) {
  var allowScrollBar = _ref11.allowScrollBar,
    removeOverflow = _ref11.removeOverflow;
  if (removeOverflow) {
    return '';
  }
  return allowScrollBar ? 'overflow: auto;' : 'overflow: hidden;';
}, function (_ref12) {
  var frameStyle = _ref12.frameStyle;
  return frameStyle === 'show' ? "\n        width: calc(100% - ".concat("var(--ds-space-200, 16px)", " - 2px);\n        margin: 0 ", "var(--ds-space-100, 8px)", " ", "var(--ds-space-100, 8px)", ";\n      ") : '';
}, function (_ref13) {
  var frameStyle = _ref13.frameStyle;
  return frameStyle === 'hide' ? 'height: 100%;' : "\n        height: calc(100% - ".concat("var(--ds-space-400, 32px)", ");\n        top: ", "var(--ds-space-400, 32px)", ";\n      ");
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-dynamic-styles, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
export var Image = styled.img(function (_ref14) {
  var size = _ref14.size;
  return csssize(size);
}, borderRadius, {
  overflow: 'hidden'
});
export var maxAvatarCount = 6;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var ContentWrapper = styled.div({
  display: 'flex',
  flexDirection: 'row',
  boxSizing: 'border-box',
  padding: "var(--ds-space-100, 8px)".concat(" ", "var(--ds-space-150, 12px)", " ", "var(--ds-space-150, 12px)", " ", "var(--ds-space-150, 12px)")
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var Title = styled.div({
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
  color: "var(--ds-text, ".concat(colors.N900, ")"),
  font: "var(--ds-font-heading-small, normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
  maxHeight: "".concat(20 * 4, "px"),
  overflow: 'hidden'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var Byline = styled.div({
  marginTop: "var(--ds-space-050, 4px)",
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
  color: "var(--ds-text-subtlest, ".concat(colors.N300, ")"),
  font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
},
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
ellipsis('100%'));

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var Description = styled.div({
  marginTop: "calc(".concat("var(--ds-space-100, 8px)", " - 1px)"),
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
  color: "var(--ds-text, ".concat(colors.N800, ")"),
  font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
  maxHeight: "".concat(18 * 3, "px"),
  overflow: 'hidden'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var ResolvedViewIconWrapper = styled.div({
  marginTop: "var(--ds-space-050, 4px)"
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
export var Thumbnail = styled.div(borderRadius, csssize(48), function (props) {
  return {
    float: 'right',
    margin: "var(--ds-space-050, 4px)".concat(" 0 ", "var(--ds-space-150, 12px)", " ", "var(--ds-space-150, 12px)"),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    backgroundColor: "var(--ds-skeleton, ".concat(colors.N30, ")"),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    backgroundImage: "url(".concat(props.src, ")"),
    backgroundSize: 'cover'
  };
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var UsersWrapper = styled.div({
  marginTop: "var(--ds-space-100, 8px)"
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var ActionsWrapper = styled.div({
  marginTop: "var(--ds-space-100, 8px)",
  textAlign: 'right',
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  '> *': {
    marginTop: "var(--ds-space-050, 4px)"
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  '> * + *': {
    marginLeft: "var(--ds-space-050, 4px)"
  }
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var AlertWrapper = styled.div({
  position: 'absolute',
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  overflow: 'hidden',
  pointerEvents: 'none',
  zIndex: maxAvatarCount + 1
});